import _ from 'lodash';
import { useEffect } from 'react';
import app from '~/app';
import { log, Session } from '@swiper/core';

export function useSwipesHandler( state, dispatch ) {

  useEffect( () => {
    log.debug( 'REGISTERING SWIPE HANDLER' );
    const update = swipe => {
      log.debug( 'SWIPE CREATED', swipe );
      dispatch( { type : 'swipe', swipe } );
    };
    const swipes = app.service( 'swipes' );
    swipes.on( 'created', update );
    return () => swipes.off( 'created', update );
  }, [ dispatch ] );

  useEffect( () => {
    const swipe = state.swipe;
    if ( ! swipe ) return;

    const methods = {

      send( data ) {
        _.assign( data, {
          ...data,
          swipeId       : swipe.id,
          sessionId     : swipe.sessionId,
          membershipId  : swipe.membershipId,
        } );
        return app.service( 'sessions' )
          .patch( swipe.sessionId, data )
          .then( session => dispatch.session( new Session( session ) ) )
          .catch( dispatch.error );
      },

      toggle( person ) {
        if ( ! person ) return;

        const dir = person.present ? 'out' : 'in';
        const rel = person.id === state.swipe.memberId
          ? 'member' : person.relation;
        const event = { event : `${rel}-${dir}` };
        if ( rel === 'member' || rel === 'family' ) {
          event.memberId = person.id;
        } else {
          event[ `${rel}Id` ] = person.id;
        }
        log.debug( 'SENDING EVENT', event );
        return this.send( event )
          .then( session => session.getPerson( person.id ) );
      },

    };
    const keys = _.keys( methods );
    _.assign( swipe, methods );

    return () => _.each( keys, key => ( delete swipe[ key ] ) );

  }, [ state.swipe, dispatch ] );

  return null;
}
